import React, { useContext } from 'react';
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useParams,
} from 'react-router-dom';
import Dashboard from './dashboard/dashboard.psa';
import Settings from './settings/settings.psa';
import MyOrganization from './myinstitution/myorganization.psa';
import Calendar from './calendarpsa/calendarpsa';
import PageNotFound from './pages/pagenotfound';
import StudiestedbrukerprofilPage from './userprofile/studiestedbrukerprofilpage.psa';
import Students from './students/students.psa';
import { PrivacyPolicyLoggedIn } from './policy/rightsandprivacy';
import {
  AboutAnalyticsPageLoggedIn,
  AboutCookiesPageLoggedIn,
} from './login/about';
import PsaUserGodtaBetingelserPage from './policy/godtabetingelserpage.psa';
import { PsaUserContext } from './user/PsaUserStore';
import EvaluationActivitiesWrapper from './evaluation/evaluationactivities';
import { UserType } from './util/userType';

const CalendarRedirect = () => {
  const { pathname } = useLocation();

  return <Navigate to={`/calendar${pathname}`} replace />;
};

const AgreementRedirect = () => {
  const { avtaleId } = useParams<{ avtaleId: string }>();

  return <Navigate to={`/myorganization/agreements/${avtaleId}`} replace />;
};

const TopRoutesPsa = () => {
  const { psaUser } = useContext(PsaUserContext);

  if (psaUser && !psaUser.innstillinger.harGodtattBetingelser) {
    return <PsaUserGodtaBetingelserPage />;
  }

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/calendar/*" element={<Calendar />} />
      <Route
        path="/activity/:activityId/:tab?"
        element={<CalendarRedirect />}
      />
      <Route
        path="/evaluation/*"
        element={<EvaluationActivitiesWrapper userType={UserType.PS} />}
      />
      <Route path="/myorganization/*" element={<MyOrganization />} />
      <Route
        path="/practiceplaces/practiceplaceagreement/:avtaleId"
        element={<AgreementRedirect />}
      />
      <Route path="/students/*" element={<Students />} />
      <Route
        path="/studiestedbrukerprofil/:id"
        element={<StudiestedbrukerprofilPage />}
      />
      <Route path="/policy" element={<PrivacyPolicyLoggedIn />} />
      <Route path="/cookies" element={<AboutCookiesPageLoggedIn />} />
      <Route path="/analytics" element={<AboutAnalyticsPageLoggedIn />} />
      <Route path="/*" element={<PageNotFound />} />
    </Routes>
  );
};

export default TopRoutesPsa;
